import { render, staticRenderFns } from "./Erazer.vue?vue&type=template&id=e216c396&scoped=true"
import script from "./Erazer.vue?vue&type=script&lang=js"
export * from "./Erazer.vue?vue&type=script&lang=js"
import style0 from "./Erazer.vue?vue&type=style&index=0&id=e216c396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e216c396",
  null
  
)

export default component.exports